import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeManageViewRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-manage-view',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
	exact: true,
};
